import "./Preview.scss";
import ButtonGroup from "../ButtonGroup";

const Preview = ({
  step,
  setStep,
  textOne,
  textTwo,
  cbStepNext,
  cbStepSkip,
}) => {
  return (
    <div className="preview__wrap">
      <div className="progress">
        <span className="active one" />
        <span className={"active" + (step === 3 || step === 4 ? " two" : "")} />
        <span className={"active" + (step === 4 ? " third" : "")} />
      </div>
      <p>{textOne}</p>
      {textTwo && <p>{textTwo}</p>}
      <ButtonGroup
        cbStepNext={cbStepNext}
        cbStepSkip={cbStepSkip}
        step={step}
        setStep={setStep}
      />
    </div>
  );
};
export default Preview;
